import React, { createContext, useState, useEffect } from "react";
export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("black");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlTheme = params.get("theme");

    if (urlTheme) {
      localStorage.setItem("theme", urlTheme);
    }

    const savedTheme = localStorage.getItem("theme");
    applyTheme(savedTheme || "black");
  }, []);

  function applyTheme(themeName) {
    const html = document.querySelector("html");
    html.classList.remove("white", "black");
    if (themeName === "white") {
      html.classList.add("white");
    }
    setTheme(themeName);
  }

  function toggleThemeMode() {
    let nextTheme;
    if (theme === "black") nextTheme = "white";
    else nextTheme = "black";

    localStorage.setItem("theme", nextTheme);
    applyTheme(nextTheme);
  }

  return (
    <ThemeContext.Provider value={{ theme, toggleThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;


// import React, { createContext, useState, useEffect } from "react";
// export const ThemeContext = createContext();

// const ThemeProvider = ({ children }) => {
//   const [theme, setTheme] = useState("dev");

//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const urlTheme = params.get("theme");

//     if (urlTheme) {
//       localStorage.setItem("theme", urlTheme);
//     }

//     const savedTheme = localStorage.getItem("theme");
//     applyTheme(savedTheme || "dev");
//   }, []);

//   function applyTheme(themeName) {
//     document.querySelector("html").classList.remove("black", "dev");
//     if (themeName !== "dev") {
//       document.querySelector("html").classList.add(themeName);
//     }
//     setTheme(themeName);
//   }

//   function toggleThemeMode() {
//     let nextTheme;
//     if (theme === "dev") nextTheme = "black";
//     else nextTheme = "dev";

//     localStorage.setItem("theme", nextTheme);
//     applyTheme(nextTheme);
//   }

//   return (
//     <ThemeContext.Provider value={{ theme, toggleThemeMode }}>
//       {children}
//     </ThemeContext.Provider>
//   );
// };

// export default ThemeProvider;
